<template>
  <v-app class="grey lighten-3" v-if="isLoggedIn">
    <div class="btn">
      <v-snackbar
        v-model="snackbar"
        :right="x === 'right'"
        :timeout="timeout"
        color="red"
        :top="y === 'top'"
      >
        {{ errorMsg }}
        <v-btn color="black" flat @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </div>
    <v-layout v-if="checkProjectLimit()">
      <v-dialog v-model="dialog" persistent max-width="600px">
        <need-assistant @click="onClickAssistant($event)" />
      </v-dialog>
      <v-flex xs12 sm12>
        <v-container grid-list-md>
          <v-card>
            <v-card-title class="project">
              <div class="white--text headline">
                <span>Create Project</span>
              </div>
              <div class="red--text headline ml-2">
                <v-btn
                  color="white darken-1"
                  small
                  dark
                  class="no-upercase red--text"
                  @click="needAssistant"
                >
                  Need assistance
                </v-btn>
              </div>
            </v-card-title>

            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-layout wrap>
                  <v-flex xs12 sm6 md6>
                    <v-select
                      v-model="projectData.project_language"
                      :rules="project_language"
                      :items="project_language_data"
                      item-text="name"
                      item-value="id"
                      box
                      label="Project language"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-select
                      v-model="projectData.project_type_id"
                      :rules="projectType"
                      :items="indexData.projectType"
                      item-text="name"
                      :disabled="isLanguageSelected"
                      item-value="id"
                      @change="calculatedPrice"
                      box
                      label="Project Type"
                    ></v-select>
                  </v-flex>
                </v-layout>
                <v-layout
                  v-if="projectData.project_type_id == 3"
                  class="mb-2 pb-2"
                >
                  <v-layout
                    wrap
                    style="background-color: #f0f0f0; border-radius: 5px"
                    class="pa-4 mx-1"
                  >
                    <v-flex xs12>
                      <v-title class="headline" style="color: #ff2e2e"
                        >Agent survey types</v-title
                      >
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex xs12>
                      <v-radio-group
                        v-model="projectData.agent_option"
                        :mandatory="true"
                      >
                        <v-radio
                          label="Default"
                          color="green"
                          value="1"
                        ></v-radio>
                        <v-radio
                          label="Offline survey"
                          color="green"
                          value="2"
                        ></v-radio>
                        <v-radio
                          label="Web link survey"
                          color="green"
                          value="3"
                        ></v-radio>
                      </v-radio-group>
                    </v-flex>
                  </v-layout>
                </v-layout>

                <v-layout wrap>
                  <v-flex getGridEng>
                    <v-text-field
                      v-model="projectData.name"
                      :rules="projectTitle"
                      :disabled="isLanguageSelected"
                      box
                      label="Project Title English"
                    ></v-text-field>
                  </v-flex>
                  <v-flex
                    getGridBn
                    v-if="
                      projectData.project_language == 2 ||
                      projectData.project_language == 3
                    "
                  >
                    <v-text-field
                      v-model="projectData.name_bangla"
                      :rules="[
                        (v) => !!v || 'Project title bangla is required',
                      ]"
                      box
                      :disabled="isLanguageSelected"
                      label="Project Title Bangla"
                      @keypress="isLetter($event)"
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout wrap>
                  <v-flex getGridEng>
                    <v-textarea
                      v-model="projectData.details"
                      box
                      label="Projects Details English"
                      :disabled="isLanguageSelected"
                    ></v-textarea>
                  </v-flex>
                  <v-flex
                    getGridBn
                    v-if="
                      projectData.project_language == 2 ||
                      projectData.project_language == 3
                    "
                  >
                    <v-textarea
                      v-model="projectData.details_bangla"
                      box
                      label="Projects Details Bangla"
                      @keypress="isLetter($event)"
                      :disabled="isLanguageSelected"
                    ></v-textarea>
                  </v-flex>
                </v-layout>

                <v-layout wrap>
                  <v-flex xs12 sm6 md6>
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="projectData.begin_date"
                          :rules="startTime"
                          box
                          label="Estimated Starting Time *"
                          readonly
                          outlined
                          :disabled="isLanguageSelected"
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="picker"
                        v-model="projectData.begin_date"
                        :min="new Date().toISOString().substr(0, 10)"
                        @change="save(date)"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-menu
                      ref="menu"
                      v-model="menu1"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="projectData.end_date"
                          :rules="endTime"
                          box
                          label="Ending Time *"
                          readonly
                          outlined
                          :disabled="isLanguageSelected"
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="picker"
                        v-model="projectData.end_date"
                        :min="new Date().toISOString().substr(0, 10)"
                        @change="save(date)"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>

                  <!-- <v-flex xs12 sm4 md4>
                    <v-text-field
                      v-model="projectData.duration"
                      :rules="time"
                      box
                      label="Task Duration(Min)"
                      @keypress="isDigit($event)"
                      :disabled="isLanguageSelected"
                    ></v-text-field>
                  </v-flex> -->
                </v-layout>
                <v-layout
                  wrap
                  v-if="
                    projectData.project_type_id == 3 &&
                    projectData.agent_option != 3
                  "
                >
                  <v-flex xs12 sm4 md4>
                    <v-checkbox
                      v-model="projectData.unlimited_task_duration"
                      label="Allow unlimited task duration"
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
                <v-layout
                  wrap
                  v-if="
                    projectData.unlimited_task_duration == false &&
                    projectData.agent_option != 3
                  "
                >
                  <v-flex xs12 sm4 md4>
                    <v-text-field
                      v-model="projectData.duration_days"
                      box
                      label="Task Duration(Days)"
                      @keypress="isDigit($event)"
                      :disabled="isLanguageSelected"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4 md4>
                    <v-text-field
                      v-model="projectData.duration_hours"
                      box
                      label="Task Duration(Hours)"
                      @keypress="isDigit($event)"
                      :disabled="isLanguageSelected"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4 md4>
                    <v-text-field
                      v-model="projectData.duration_minutes"
                      :rules="time"
                      box
                      label="Task Duration(Minutes)"
                      @keypress="isDigit($event)"
                      :disabled="isLanguageSelected"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout wrap v-if="projectData.project_type_id == 2">
                  <v-flex xs12 sm3 md3>
                    <div class="title mt-3">Project Distance Radius</div>
                  </v-flex>
                  <v-flex xs12 sm1 md1>
                    <v-checkbox
                      v-model="projectData.edit_distance_radius"
                      @change="checkUncheckDistance"
                      label="Edit"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs12 sm4 md4>
                    <v-text-field
                      v-model="projectData.visual_distance_km"
                      box
                      label="Visual distance(Km)"
                      :disabled="!projectData.edit_distance_radius"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4 md4>
                    <v-text-field
                      v-model="projectData.acceptance_distance_meter"
                      box
                      label="Acceptance distance(Meter)"
                      :disabled="!projectData.edit_distance_radius"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout
                  wrap
                  v-if="
                    (projectData.project_type_id == 1 ||
                      projectData.project_type_id == 2) &&
                    hasPreSurvey()
                  "
                >
                  <v-flex xs12 sm12 md12>
                    <v-checkbox
                      v-model="projectData.has_pre_survey"
                      label="Pre-Survey"
                      required
                      :disabled="isLanguageSelected"
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
                <v-layout wrap v-if="projectData.has_pre_survey">
                  <v-flex getGridEng>
                    <v-textarea
                      v-model="projectData.pre_survey_descriptions"
                      box
                      label="Pre Survey Details"
                    ></v-textarea>
                  </v-flex>
                  <v-flex
                    getGridBn
                    v-if="
                      projectData.project_language == 2 ||
                      projectData.project_language == 3
                    "
                  >
                    <v-textarea
                      v-model="projectData.pre_survey_descriptions_bangla"
                      box
                      label="Pre Survey Details Bangla"
                      @keypress="isLetter($event)"
                      :disabled="isLanguageSelected"
                    ></v-textarea>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-checkbox
                v-model="projectData.is_otp_required"
                label="OTP Verification required"
                required
                :disabled="isLanguageSelected"
                v-if="hasMobileOTPVerification()"
              ></v-checkbox>
              <v-spacer></v-spacer>
              <v-switch
                v-if="projectData.project_type_id == 2"
                v-model="projectData.multi_task"
                label="Multi-Task"
                color="success"
                value="1"
                hide-details
              ></v-switch>
              <v-spacer></v-spacer>
              <v-btn
                class="button"
                flat
                @click="submit"
                :disabled="isLanguageSelected"
              >
                Save & next
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>
    <v-layout v-else>
      <div class="ml-10 mt-10 black--text headline">
        <v-container>
          <v-card class="ml-10 mt-10 text-center">
            <v-card-text>
              You have exceed your allowed survey limit for this month
            </v-card-text>
          </v-card>
        </v-container>
      </div>
    </v-layout>
  </v-app>
  <v-layout v-else>
    <Signin class="mt-1"></Signin>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
// import router from "../../router";
import Signin from "../../views/auth/Signin";
import { NeedAssistant } from "@/components/index";
import utilities from "../../api/utilities.js";
export default {
  components: {
    Signin,
    NeedAssistant,
  },

  data: () => ({
    apiUrl: "project-type",
    menu: false,
    menu1: false,
    dialog: false,
    menu2: false,
    snackbar: false,
    y: "top",
    x: "right",
    timeout: 4000,
    allowedMaxProjectLimit: null,
    project_language_data: [
      { name: "English", id: 1 },
      { name: "Bangla", id: 2 },
      { name: "English & Bangla both", id: 3 },
    ],
    date: null,
    field_enable: true,
    projectData: {
      name: "",
      name_bangla: "",
      project_type_id: "",
      details: "",
      details_bangla: "",
      is_otp_required: false,
      begin_date: "",
      end_date: "",
      project_language: "",
      duration_days: 0,
      duration_hours: 0,
      duration_minutes: 0,
      has_pre_survey: false,
      pre_survey_descriptions: "",
      pre_survey_descriptions_bangla: "",
      visual_distance_km: null,
      acceptance_distance_meter: null,
      edit_distance_radius: false,
      unlimited_task_duration: false,
      id: null,
      agent_option: "1",
      multi_task: "",
    },
    editedIndex: -1,
    defaultItem: {
      name: "",
      name_bangla: "",
      project_type_id: "",
      details: "",
      details_bangla: "",
      begin_date: "",
      end_date: "",
      is_otp_required: false,
      project_language: "",
      duration_days: 0,
      duration_hours: 0,
      duration_minutes: 0,
      has_pre_survey: false,
      pre_survey_descriptions: "",
      pre_survey_descriptions_bangla: "",
      visual_distance_km: null,
      acceptance_distance_meter: null,
      edit_distance_radius: false,
      unlimited_task_duration: false,
      id: null,
      agent_option: "1",
      multi_task: "",
    },
    submitData: {
      data: [],
    },
    valid: true,
    projectTitle: [(v) => !!v || "Project title is required"],
    projectType: [(v) => !!v || "Select a project type"],
    startTime: [(v) => !!v || "Enter project starting time"],
    endTime: [(v) => !!v || "Enter project ending time"],
    time: [(v) => !!v || "Time is required."],
    project_language: [(v) => !!v || "Project language is required."],
  }),

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "clientId",
      "subscriptionData",
      "error",
      "statusCode",
      "errorMsg",
    ]),
    getGridEng() {
      if (this.projectData.project_language == 1) {
        return "xs12 sm12 md12";
      } else {
        return "xs6 sm6 md6";
      }
    },
    getGridBn() {
      if (this.projectData.project_language == 2) {
        return "xs12 sm12 md12";
      } else {
        return "xs6 sm6 md6";
      }
    },
    isLanguageSelected() {
      if (this.projectData.project_language == "") {
        return true;
      } else {
        return false;
      }
    },

    binding() {
      const binding = {};

      if (this.$vuetify.breakpoint.mdAndUp) binding.column = true;

      return binding;
    },
  },

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "DATE"));
    },
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
    // this.editedData()
  },
  methods: {
    initialize() {
      this.$store.dispatch("setIndexData", [this.apiUrl]);
    },
    calculatedPrice(event) {
      let val = this.indexData.projectType[event - 1].min_price;
      this.projectData.visual_distance_km =
        this.indexData.nearbyRadius.visual_radius_km;
      this.projectData.acceptance_distance_meter =
        this.indexData.nearbyRadius.acceptance_radius_m;
      this.$cookie.set("filter_val", val);
      this.projectData.agent_option = 1;
    },
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (!/^[A-Za-z]+$/.test(char)) return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
    isDigit(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[0-9]+$/.test(char)) return false;
      // Match with regex
      else {
        this.digitValidate = true;
        e.preventDefault();
      } // If not match, don't add to input text
    },
    save(date) {
      this.$refs.menu.save(date);
      this.menu = false;
    },
    checkUncheckDistance() {
      if (this.projectData.edit_distance_radius == false) {
        this.projectData.visual_distance_km =
          this.indexData.nearbyRadius.visual_radius_km;
        this.projectData.acceptance_distance_meter =
          this.indexData.nearbyRadius.acceptance_radius_m;
      }
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    needAssistant() {
      this.dialog = true;
      // this.snackbar = true;
      // this.close();
    },
    onClickAssistant(event) {
      if (event == 1) {
        this.dialog = false;
        this.snackbar = true;
        this.close;
      } else {
        this.dialog = false;
      }
    },
    checkProjectLimit() {
      if (utilities.clientId() == 1) {
        this.allowedMaxProjectLimit = 10000;
        return true;
      }
      this.allowedMaxProjectLimit = utilities.allowedProjectLimit(
        this.subscriptionData.subscriptionFeatures
      );
      // console.log(this.allowedMaxProjectLimit);
      var totalProject = 0;
      if (this.indexData.totalProjects) {
        totalProject = this.indexData.totalProjects;
      }
      if (this.allowedMaxProjectLimit > totalProject) {
        return true;
      }
      return false;
    },
    hasPreSurvey() {
      if (utilities.clientId() == 1) {
        return true;
      }
      if (utilities.hasPreSurvey(this.subscriptionData.subscriptionFeatures)) {
        return true;
      }
      return false;
    },
    hasMobileOTPVerification() {
      if (utilities.clientId() == 1) {
        return true;
      }
      // console.log(hasPreSurvey1);
      if (
        utilities.hasMobileOTPVerification(
          this.subscriptionData.subscriptionFeatures
        )
      ) {
        return true;
      }
      return false;
    },
    submit() {
      // console.log(this.projectData);
      if (this.$refs.form.validate()) {
        this.submitData.data = this.projectData;
        this.$store.dispatch("storeOrUpdateProject", [
          "project",
          this.submitData,
        ]);
        localStorage.setItem("project_data", null);
        localStorage.setItem("project_id_edit", null);
        this.snackbar = true;
        this.close();
      }
    },
  },
};
</script>

<style scoped>
.icon {
  background: #ff2e2e;
  color: aliceblue;
  cursor: pointer;
  border-radius: none;
  margin: 10px;
}
.delete {
  color: #3f51b5;
  cursor: pointer;
}
span {
  width: 30px;
  cursor: pointer;
}
.button {
  font-size: 16px;
  background: #ff2e2e;
  padding: 0.4rem 1.3rem;
  text-align: center;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  margin: 10px;
  color: white;
}
.headline {
  color: white;
}
.no-upercase {
  text-transform: unset !important;
}
.project {
  background: #ff2e2e;
}
</style>
